import styles from './add-customer-group-dialog.module.scss';
import { CompanySearch, Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, PrimaryButton, SnackBarContext } from '@frontend-workspace/react-shared-lib';
import { useContext, useState } from 'react';
import { ContactListContext } from '../../customer-context/customer-context';
import { useTranslation } from 'react-i18next';
import { useMakeRequestHook } from '../../requestUtils';

/* eslint-disable-next-line */
export interface AddCustomerGroupDialogProps {
  open: boolean,
  onClose: () => void,
  companyNumber: string
}

export function AddCustomerGroupDialog(props: AddCustomerGroupDialogProps) {
  const contactList = useContext(ContactListContext);
  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const makeRequest = useMakeRequestHook();
  const [selectedCompanyNumber, setSelectedCompanyNumber] = useState<string | undefined>(undefined);
  const handleCompanyChange = (companyNumber: string) => setSelectedCompanyNumber(companyNumber);

  const handleAddDaughterCompany = () => {
    const selectedCompany = contactList.find(c => c.number === selectedCompanyNumber);
    if (selectedCompany) {
      makeRequest(`companies/${props.companyNumber}/action/AddToGroup/${selectedCompany.number}`, 'PUT').then(result => {
        setSnackbarMessage({ content: t('addCustomerGroup.companyAddedToGroup'), type: "success" });
        props.onClose();
      }).catch(() => setSnackbarMessage({ content: t('addCustomerGroup.couldNotAddCompanyToGroup'), type: "error" }));
    }
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => props.onClose()}
      maxWidth="md"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t('standard.addCompanyDepartment')}
      </DialogTitle>
      <DialogContent>
        <CompanySearch
          selectedCompanyNumber={selectedCompanyNumber}
          companyList={contactList}
          onChange={handleCompanyChange} />
      </DialogContent>
      <DialogActions>
        <PrimaryButton
          variant="contained"
          size='large'
          onClick={handleAddDaughterCompany}
          className='minButtonWidth'>
          OK
        </PrimaryButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t('standard.cancel')}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default AddCustomerGroupDialog;